import { Handshake, Check } from "lucide-react";
import { Reveal, FadeUp } from "@/components/site/Reveal";
import { useSiteContent } from "@/context/ContentContext";

export default function Partner() {
  const { partner: PARTNER } = useSiteContent();
  return (
    <section id="partner" data-testid="partner-section" className="relative bg-[#f1f5f9] py-24 md:py-32 border-y border-[#0f172a]/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Partner logos */}
        <div className="lg:col-span-5 order-2 lg:order-1">
          <FadeUp>
            <div data-testid="partner-logo" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-5">
              {/* Modify */}
              <div className="flex items-center justify-center bg-white border border-[#0f172a]/10 shadow-[0_20px_60px_-30px_rgba(33,29,24,0.4)] px-8 py-12">
                <img src="/brand/modify-logo.png" alt="Modify" loading="lazy" decoding="async" className="h-14 md:h-16 w-auto object-contain" />
              </div>
              {/* Exclusive Tiling & Stone */}
              <div className="flex flex-col items-center justify-center gap-4 bg-white border border-[#0f172a]/10 shadow-[0_20px_60px_-30px_rgba(33,29,24,0.4)] px-8 py-10">
                <img src="/brand/ets-emblem-clean.png" alt="Exclusive Tiling & Stone" loading="lazy" decoding="async" className="h-14 md:h-16 w-auto object-contain" />
                <div className="text-center">
                  <p className="font-serif text-4xl md:text-5xl text-[#0f172a] tracking-[0.18em] pl-[0.18em]">ETS</p>
                  <p className="overline !text-[#9c7a4d] !text-[0.55rem] mt-2">Exclusive Tiling &amp; Stone</p>
                </div>
              </div>
            </div>
            <p className="overline !text-[#9c7a4d] !text-[0.6rem] text-center mt-6">Collaboration Partners</p>
          </FadeUp>
        </div>

        {/* Copy */}
        <div className="lg:col-span-6 lg:col-start-7 order-1 lg:order-2">
          <p className="overline !text-[#9c7a4d] mb-6 flex items-center gap-2">
            <Handshake className="h-4 w-4" /> {PARTNER.overline}
          </p>
          <h2 className="font-serif font-light text-[#0f172a] text-4xl sm:text-5xl lg:text-6xl leading-[0.98] tracking-tight mb-8">
            <Reveal>Scaling craft,</Reveal>
            <Reveal delay={0.08}>together.</Reveal>
          </h2>
          <FadeUp>
            <p className="text-[#475569] text-lg md:text-xl font-light leading-relaxed mb-10">{PARTNER.body}</p>
          </FadeUp>
          <ul className="space-y-4">
            {PARTNER.points.map((p, i) => (
              <FadeUp key={p} delay={0.06 + i * 0.06}>
                <li className="flex items-start gap-4 border-b border-[#0f172a]/10 pb-4">
                  <Check className="h-5 w-5 text-[#9c7a4d] shrink-0 mt-0.5" />
                  <span className="text-[#1e293b] text-base md:text-lg font-light">{p}</span>
                </li>
              </FadeUp>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
